import React, { useEffect, useState, useRef } from "react";
import { Col, Row } from "antd";
import { useSelector } from "react-redux";
import LogoTile from "./LogoTile";
import styles from "./style.scss";
import { useParams } from "react-router-dom";
import { selectAdData } from "../../../../routes/AdForm/adForm.ducks";

// eslint-disable-next-line complexity
const LogoSelector = props => {
  const { options, title, value, onChange, changeForbidden } = props;
  const brands = [...options];
  const numOfBrands = options.length;
  let gridSettings: any = { xs: 8 };

  const [disabledEdit, setDisabledEdit] = useState(false);
  // @ts-ignore
  const { id } = useParams();
  const adData = useSelector(selectAdData);

  // Decide lock based on the ORIGINAL ad data (from redux), not the current
  // form value — the latter changes when the user clicks a tile and would
  // wrongly lock the field on a Njuškalo-migrated ad without a make. Ad data
  // loads async, so we wait for it to appear and then decide once.
  //
  // We require BOTH make and model to be present on the ad — locking make
  // while model is missing would leave the user unable to finish the ad.
  const decisionMade = useRef(false);
  useEffect(() => {
    if (decisionMade.current) return;
    if (!changeForbidden || !id) {
      decisionMade.current = true;
      return;
    }
    if (!adData) return;
    decisionMade.current = true;
    if (adData.makeId && adData.modelId) {
      setDisabledEdit(true);
    }
  }, [adData, changeForbidden, id]);

  if (numOfBrands === 0 || numOfBrands < 3) {
    return null;
  }

  if (numOfBrands >= 6) {
    brands.splice(6);
    gridSettings = { ...gridSettings, sm: 4 };
  } else if (numOfBrands >= 3 && numOfBrands < 6) {
    brands.splice(3);
  }

  return (
    <React.Fragment>
      <span className="control-title">{title}</span>
      <Row type="flex" justify="space-between" gutter={10}>
        {brands.map(option => (
          <Col className={styles.tile} key={option.value} {...gridSettings}>
            <LogoTile
              onClick={() => onChange(option.value)}
              isSelected={option.value === value}
              logoId={option.logoId}
              title={option.title}
              disabled={disabledEdit}
            />
          </Col>
        ))}
      </Row>
    </React.Fragment>
  );
};

LogoSelector.defaultProps = {
  value: null
};

export default LogoSelector;



// WEBPACK FOOTER //
// ./src/components/FormControls/MultiLevelSelectorWithLogo/LogoSelector/index.tsx